(() => {
  if (window.StudioCatalog) return;
  const $ = (query, scope = document) => scope.querySelector(query);
  const $$ = (query, scope = document) => [...scope.querySelectorAll(query)];
  const readJSON = node => { try { return JSON.parse(node?.textContent || '{}'); } catch { return {}; } };
  const translations = () => readJSON($('[data-st-catalog-i18n]'));
  const t = key => translations()[key] || key.replaceAll('_', ' ');
  const base = () => window.Studio?.config?.root || window.Shopify?.routes?.root || '/';
  const endpoint = path => base() + path.replace(/^\//, '');
  const money = amount => window.StudioCommerce?.money(amount) || new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:window.Studio?.config?.currency || window.Shopify?.currency?.active || 'USD'}).format(Number(amount || 0) / 100);
  const memory = new Map();
  const read = key => { try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.filter(item => typeof item === 'string') : []; } catch { return memory.get(key) || []; } };
  const write = (key, value) => { memory.set(key, value); try { localStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const cardCache = new Map(), productCache = new Map();
  async function cached(cache, key, load) {
    if (!cache.has(key)) cache.set(key, load().catch(error => { cache.delete(key); throw error; }));
    return cache.get(key);
  }
  const fetchProduct = handle => cached(productCache, handle, async () => {
    const response = await fetch(endpoint('products/' + encodeURIComponent(handle) + '.js'), {credentials:'same-origin'});
    if (!response.ok) throw new Error(t('request_failed'));
    return response.json();
  });
  const fetchCard = handle => cached(cardCache, handle, async () => {
    const url = new URL(endpoint('products/' + encodeURIComponent(handle)), location.origin);
    url.searchParams.set('section_id', 'recently-viewed-products');
    const response = await fetch(url, {credentials:'same-origin'});
    if (!response.ok) throw new Error(t('request_failed'));
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const card = parsed.querySelector('template[data-st-server-card]')?.content.querySelector('.st-product-card');
    if (!card) throw new Error(t('request_failed'));
    return card.outerHTML;
  });
  const cardNode = html => { const template = document.createElement('template'); template.innerHTML = html; return template.content.firstElementChild; };
  const retryMessage = (scope, retry) => {
    const message = document.createElement('p'); message.setAttribute('role', 'status'); message.textContent = t('request_failed');
    const button = document.createElement('button'); button.type = 'button'; button.className = 'st-button'; button.textContent = t('retry');
    button.addEventListener('click', retry, { once: true }); scope.append(message, button);
  };
  const comparisonHandles = () => read('studio.compare').slice(0, Number(window.Studio?.config?.maxCompare) || 5);
  function syncCompareButtons() { const handles = comparisonHandles(); $$('[data-st-catalog-compare], [data-st-compare-add]').forEach(button => button.setAttribute('aria-pressed', String(handles.includes(button.dataset.stCatalogCompare || button.dataset.stCompareAdd)))); }
  function comparisonStatus(message) {
    const dialog = $('#studio-compare-dialog');
    if (!dialog) return;
    let status = $('[data-st-comparison-status]', dialog);
    if (!status) { status = document.createElement('p'); status.dataset.stComparisonStatus = ''; status.setAttribute('role','status'); $('.st-dialog-heading', dialog)?.after(status); }
    status.textContent = message;
  }
  async function addCompare(handle) {
    if (!handle) return;
    const handles = comparisonHandles(), max = Number(window.Studio?.config?.maxCompare) || 5;
    if (!handles.includes(handle)) {
      if (handles.length >= max) comparisonStatus(t('compare_limit').replace('__COUNT__', max));
      else { write('studio.compare', [...handles, handle]); comparisonStatus(''); }
    }
    syncCompareButtons();
    $$('studio-catalog-compare:not([data-recommendations])').forEach(node => node.load());
    const dialog = $('#studio-compare-dialog');
    if (dialog && !dialog.open) { dialog.showModal(); $('[data-st-dialog-close]', dialog)?.focus(); }
  }
  function removeCompare(handle) { write('studio.compare', comparisonHandles().filter(item => item !== handle)); syncCompareButtons(); $$('studio-catalog-compare:not([data-recommendations])').forEach(node => node.load()); }
  class CatalogRail extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.track = $('[data-st-rail-track]', this);
      if (!this.track) return;
      this.addEventListener('click', event => {
        const direction = event.target.closest('[data-st-rail-prev]') ? -1 : event.target.closest('[data-st-rail-next]') ? 1 : 0;
        if (!direction) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({left:direction * rtl * this.track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto':'smooth'});
      }, {signal:this.abort.signal});
      this.track.addEventListener('scroll', () => this.update(), {passive:true,signal:this.abort.signal});
      this.track.addEventListener('load', () => this.update(), {capture:true,signal:this.abort.signal});
      window.addEventListener('resize', () => this.update(), {passive:true,signal:this.abort.signal});
      this.observer = new MutationObserver(() => this.update()); this.observer.observe(this.track,{childList:true});
      if (window.ResizeObserver) { this.resizeObserver = new ResizeObserver(() => this.update()); this.resizeObserver.observe(this.track); }
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.resizeObserver?.disconnect(); }
    update() {
      if (!this.track) return;
      const mobile = matchMedia('(max-width: 767px)').matches;
      const enabled = (mobile ? this.dataset.mobileSlider : this.dataset.desktopSlider) === 'true';
      this.classList.toggle('st-rail-active', enabled);
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const media = $('.st-product-card__media', this.track);
      const railBounds = this.getBoundingClientRect(), trackBounds = this.track.getBoundingClientRect();
      const mediaBounds = media?.getBoundingClientRect();
      const center = this.classList.contains('st-nav-center_image') && mediaBounds?.height
        ? mediaBounds.top - railBounds.top + mediaBounds.height / 2
        : trackBounds.top - railBounds.top + trackBounds.height / 2;
      if (center > 0) this.style.setProperty('--st-rail-control-top', center + 'px');
      const position = Math.min(max, Math.abs(this.track.scrollLeft));
      const controls = $('[data-st-rail-controls]', this); if (controls) controls.hidden = !enabled || max < 2;
      const prev = $('[data-st-rail-prev]', this), next = $('[data-st-rail-next]', this), progress = $('[data-st-rail-progress]', this);
      if (prev) prev.disabled = position < 2;
      if (next) next.disabled = position >= max - 2;
      if (progress) progress.value = max ? position / max * 100 : 100;
    }
  }
  class CatalogRecent extends HTMLElement {
    connectedCallback() { this.load(); }
    async load() {
      const turn = this.turn = (this.turn || 0) + 1;
      const handles = [...new Set(read('studio.recent'))].filter(handle => handle !== this.dataset.current).slice(0, Number(this.dataset.limit) || 8);
      if (!handles.length) return;
      this.querySelector('[data-st-recent-error]')?.remove();
      this.setAttribute('aria-busy', 'true');
      const results = await Promise.allSettled(handles.map(fetchCard));
      if (turn !== this.turn || !this.isConnected) return;
      const cards = results.filter(result => result.status === 'fulfilled').map(result => cardNode(result.value));
      const ratio = this.dataset.ratio;
      if (ratio) cards.forEach(card => {
        const image = $('.st-product-card__image', card);
        const imageRatio = Number(image?.getAttribute('width')) / Number(image?.getAttribute('height'));
        card.style.setProperty('--st-image-ratio', ratio === 'adapt' ? String(Number.isFinite(imageRatio) && imageRatio > 0 ? imageRatio : 1) : ratio);
      });
      $('[data-st-rail-track]',this)?.replaceChildren(...cards);
      if (cards.length || results.some(result => result.status === 'rejected')) this.closest('[data-st-recent-section]').hidden = false;
      if (results.some(result => result.status === 'rejected')) {
        const error = document.createElement('div'); error.dataset.stRecentError = ''; this.append(error);
        retryMessage(error, () => this.load());
      }
      this.removeAttribute('aria-busy');
      syncCompareButtons();
    }
    disconnectedCallback() { this.turn = (this.turn || 0) + 1; }
  }
  class CatalogExpand extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.content = $('[data-st-expand-content]', this); this.button = $('[data-st-catalog-expand]', this);
      if (!this.content || !this.button) return;
      this.button.addEventListener('click', () => { this.expanded = !this.expanded; this.update(); }, {signal:this.abort.signal});
      this.content.addEventListener('focusin', event => {
        if (this.expanded || this.button.hidden) return;
        const bounds = this.content.getBoundingClientRect(), target = event.target.getBoundingClientRect();
        if (this.content.scrollTop > 0 || target.bottom > bounds.bottom) { this.expanded = true; this.content.scrollTop = 0; this.update(); }
      }, {signal:this.abort.signal});
      window.addEventListener('resize', () => this.update(), {signal:this.abort.signal});
      this.content.addEventListener('load', () => this.update(), {capture:true,signal:this.abort.signal});
      if (window.ResizeObserver) { this.observer = new ResizeObserver(() => this.update()); this.observer.observe(this.content); }
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    update() {
      if (!this.content) return;
      const limit = Number(matchMedia('(max-width: 767px)').matches ? this.dataset.mobileHeight : this.dataset.height) || 0;
      const needed = limit > 0 && this.content.scrollHeight > limit + 2;
      this.button.hidden = !needed;
      this.button.setAttribute('aria-expanded', String(Boolean(this.expanded)));
      this.button.textContent = t(this.expanded ? 'view_less' : 'view_more');
      this.content.style.setProperty('max-height', needed && !this.expanded ? limit + 'px' : 'none', 'important');
      this.content.style.overflow = needed && !this.expanded ? 'hidden' : 'visible';
    }
  }
  class CatalogComparison extends HTMLElement {
    connectedCallback() { this.load(); }
    disconnectedCallback() { this.turn = (this.turn || 0) + 1; }
    async load() {
      const turn = this.turn = (this.turn || 0) + 1;
      const content = $('[data-st-comparison-content]', this); if (!content) return;
      content.setAttribute('aria-busy','true');
      try {
        let handles = comparisonHandles();
        const fields = readJSON($('[data-st-comparison-fields]',this));
        const settings = Array.isArray(fields) ? fields : [];
        const info = settings.find(field=>field.type==='info');
        if (this.dataset.recommendations) {
          if (!this.dataset.current) { this.hidden = true; return; }
          const response = await fetch(this.dataset.recommendations,{credentials:'same-origin'});
          if (!response.ok) throw new Error(t('request_failed'));
          const result = await response.json();
          handles = [...new Set([this.dataset.current,...(result.products || []).map(product=>product.handle)])].slice(0, Number(this.dataset.limit) || 12);
        }
        const results = await Promise.allSettled(handles.map(async handle => ({product:await fetchProduct(handle),card:info ? await fetchCard(handle).catch(() => null) : null})));
        if (turn !== this.turn || !this.isConnected) return;
        const entries = results.filter(result => result.status === 'fulfilled').map(result => result.value);
        if (!entries.length) { content.replaceChildren(); if (handles.length) retryMessage(content, () => this.load()); else content.textContent = t('empty_compare'); return; }
        const wrapper = document.createElement('div'); wrapper.className = 'st-table-scroll';
        const table = document.createElement('table'); table.className = 'st-table st-comparison-table'; wrapper.append(table);
        const head = document.createElement('thead'), headings = document.createElement('tr');
        headings.append(document.createElement('th')); head.append(headings); table.append(head);
        entries.forEach(({product,card})=>{
          const cell=document.createElement('th'); cell.scope='col';
          if (info && card) { const node=cardNode(card); if (this.dataset.imageBorder==='true') node.classList.add('st-compare-image-border'); cell.append(node); }
          else { const title=document.createElement('a'); title.href=endpoint('products/'+encodeURIComponent(product.handle)); title.textContent=product.title; cell.append(title); }
          if (info?.settings?.show_view_details_button) { const link=document.createElement('a'); link.className='st-button'; link.href=endpoint('products/'+encodeURIComponent(product.handle)); link.textContent=t('view_details'); cell.append(link); }
          if (!this.dataset.recommendations) { const button=document.createElement('button'); button.type='button'; button.dataset.stCatalogCompareRemove=product.handle; button.className='st-text-button'; button.textContent=t('remove'); cell.append(button); }
          headings.append(cell);
        });
        const body=document.createElement('tbody'); table.append(body);
        settings.filter(field=>field.type!=='info').forEach(field=>{
          const row=document.createElement('tr'), label=document.createElement('th'); label.scope='row'; label.textContent=t(field.type);row.append(label);
          entries.forEach(({product})=>{
            const cell=document.createElement('td');
            if(field.type==='price')cell.textContent=money(product.price);
            else if(field.type==='variants')cell.textContent=(product.options||[]).map(option=>typeof option==='string'?option:option.name+': '+(option.values||[]).join(', ')).join(' · ');
            else if(field.type==='description') {
              const description=document.createElement('div'); description.className='st-comparison-description';description.textContent=new DOMParser().parseFromString(product.description||'','text/html').body.textContent;
              const limit=field.settings?.text_line_limit;
              if(limit && limit!=='none'){description.classList.add('st-description-clamped');description.style.setProperty('--st-description-lines',parseInt(limit,10)||3);}
              cell.append(description);
              if(field.settings?.show_view_more_button&&limit!=='none'){const button=document.createElement('button');button.type='button';button.className='st-text-button';button.dataset.stDescriptionExpand='';button.setAttribute('aria-expanded','false');button.textContent=t('view_more');cell.append(button);}
            } else cell.textContent=product[field.type]||'—';
            row.append(cell);
          });body.append(row);
        });
        content.replaceChildren(wrapper);syncCompareButtons();
        if(results.some(result=>result.status==='rejected') || info && entries.some(entry=>!entry.card)) retryMessage(content, () => this.load());
      } catch { if(turn===this.turn && this.isConnected) { content.replaceChildren(); retryMessage(content, () => this.load()); } }
      finally { if(turn===this.turn)content.removeAttribute('aria-busy'); }
    }
  }
  const paginationState = new WeakMap();
  function pagination(section) {
    const current = $('[data-st-catalog-pagination]', section);
    if(!current || paginationState.has(section))return;
    const state={busy:false,loaded:new Set(),observer:null,request:null};paginationState.set(section,state);
    state.watch=()=>{
      state.observer?.disconnect();
      const control=$('[data-st-load-more]',section);
      if(currentMode(section)==='infinite'&&control&&window.IntersectionObserver){state.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting))loadMore(section);},{rootMargin:'300px'});state.observer.observe(control);}
    };state.watch();
  }
  async function loadMore(section) {
    const state=paginationState.get(section);const control=$('[data-st-load-more]',section);if(!state||state.busy||!control)return;
    const target=new URL(control.href,location.href);if(target.origin!==location.origin)return;
    const key=target.href;if(state.loaded.has(key))return;
    state.busy=true;state.request=new AbortController();state.observer?.disconnect();control.setAttribute('aria-disabled','true');
    const status=$('[data-st-catalog-status]',section);if(status)status.textContent=t('loading');
    try {
      target.searchParams.set('section_id',section.dataset.stCatalogSection);
      const response=await fetch(target,{credentials:'same-origin',signal:state.request.signal});if(!response.ok)throw new Error();
      const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
      if(!section.isConnected || paginationState.get(section)!==state)return;
      const replacement=$('[data-st-catalog-section]',parsed);
      const incoming=$('[data-st-catalog-items]',replacement||parsed);if(!incoming)throw new Error();
      const items=$('[data-st-catalog-items]',section);const first=incoming.firstElementChild;
      items.append(...incoming.children);state.loaded.add(key);
      const next=$('[data-st-load-more]',replacement||parsed);
      if(next){control.href=next.href;control.removeAttribute('aria-disabled');}else control.remove();
      if(status)status.textContent=t('loaded');
      if(currentMode(section)!=='infinite'&&first){first.tabIndex=-1;first.focus({preventScroll:true});}
      syncCompareButtons();document.dispatchEvent(new CustomEvent('studio:catalog-appended',{detail:{section}}));
    }catch(error){if(error.name!=='AbortError' && section.isConnected){if(status)status.textContent=t('load_failed');control.removeAttribute('aria-disabled');}}
    finally{state.busy=false;if(section.isConnected && paginationState.get(section)===state && state.loaded.has(key))state.watch();}
  }
  const currentMode = section => $('[data-st-catalog-pagination]',section)?.dataset.mode;
  const facetState = new WeakMap();
  const matching = (selector, scope) => [...(scope.matches?.(selector) ? [scope] : []), ...$$(selector, scope)];
  function init(scope=document) {
    matching('[data-st-catalog-section]',scope).forEach(pagination);
    matching('[data-st-facets]',scope).forEach(details=>{
      if(facetState.has(details))return;
      const abort = new AbortController(); facetState.set(details, abort);
      const panel=$('.st-facet-panel',details), vertical=details.classList.contains('st-facet-mode-vertical');
      if(!panel)return;
      let mobile = matchMedia('(max-width: 1023px)').matches;
      if(vertical)details.open=!mobile;
      const synchronize = (focus=false) => {
        const overlay=!vertical||matchMedia('(max-width: 1023px)').matches;
        if(details.open&&overlay){panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');panel.setAttribute('aria-label',t('filter_sort'));if(focus)$('[data-st-facet-close]',panel)?.focus();}
        else{panel.removeAttribute('role');panel.removeAttribute('aria-modal');}
      };
      details.addEventListener('toggle',()=>synchronize(true),{signal:abort.signal});
      window.addEventListener('resize',()=>{const next=matchMedia('(max-width: 1023px)').matches;if(vertical && next!==mobile)details.open=!next;mobile=next;synchronize();},{signal:abort.signal});
      synchronize();
    });
    syncCompareButtons();
  }
  document.addEventListener('click',event=>{
    const more=event.target.closest('[data-st-load-more]');if(more){if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();loadMore(more.closest('[data-st-catalog-section]'));return;}
    const add=event.target.closest('[data-st-catalog-compare], [data-st-compare-add]');if(add){event.preventDefault();addCompare(add.dataset.stCatalogCompare||add.dataset.stCompareAdd);return;}
    const remove=event.target.closest('[data-st-catalog-compare-remove]');if(remove){removeCompare(remove.dataset.stCatalogCompareRemove);return;}
    const expand=event.target.closest('[data-st-description-expand]');if(expand){const text=expand.previousElementSibling;const expanded=expand.getAttribute('aria-expanded')==='true';expand.setAttribute('aria-expanded',String(!expanded));expand.textContent=t(expanded?'view_more':'view_less');text?.classList.toggle('st-description-clamped',expanded);return;}
    const close=event.target.closest('[data-st-facet-close]');if(close){const details=close.closest('[data-st-facets]');details.open=false;$('.st-facet-open',details)?.focus();return;}
    const layout=event.target.closest('[data-st-layout]');if(layout){$$('[data-st-layout]',layout.parentElement).forEach(button=>button.setAttribute('aria-pressed',String(button===layout)));return;}
    const swatch=event.target.closest('[data-st-card-swatch]');if(!swatch||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    if(!swatch.dataset.variant || swatch.dataset.productHandle && swatch.dataset.productHandle!==swatch.closest('.st-product-card')?.dataset.productHandle)return;
    event.preventDefault();const card=swatch.closest('.st-product-card');if(!card)return;
    $$('[data-st-card-swatch]',card).forEach(item=>item.setAttribute('aria-current',String(item===swatch)));
    $$('[data-st-card-link]',card).forEach(link=>link.href=swatch.href);
    $$('[data-st-quick-view]',card).forEach(button=>button.dataset.stQuickView=swatch.href);
    const image=$('.st-product-card__image',card);if(image&&swatch.dataset.image){image.src=swatch.dataset.image;image.removeAttribute('srcset');}
    card.classList.add('st-card-variant-preview');
    if(swatch.dataset.price){const price=$('[data-st-card-price]',card);if(price){price.textContent=money(Number(swatch.dataset.price));if(Number(swatch.dataset.comparePrice)>Number(swatch.dataset.price)){const strike=document.createElement('s');strike.textContent=money(Number(swatch.dataset.comparePrice));price.append(' ',strike);}}}
  });
  document.addEventListener('keydown',event=>{
    const details=event.target.closest('[data-st-facets]');
    if(!details?.open)return;
    if(event.key==='Escape' && $('.st-facet-panel[aria-modal=true]',details)){event.preventDefault();details.open=false;$('.st-facet-open',details)?.focus();}
    if(event.key==='Tab'&&$('.st-facet-panel[aria-modal=true]',details)){
      const nodes=$$('button:not(:disabled),a[href],input:not(:disabled):not([type=hidden]),select:not(:disabled),summary', $('.st-facet-panel',details)).filter(node=>(!node.closest('details:not([open])')||node.tagName==='SUMMARY')&&!node.closest('[hidden]')&&getComputedStyle(node).display!=='none'&&getComputedStyle(node).visibility!=='hidden');
      const first=nodes[0],last=nodes.at(-1);
      if(event.shiftKey&&event.target===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&event.target===last){event.preventDefault();first?.focus();}
    }
  });
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:block:select',event=>{
    const panel=event.target.closest('[role=tabpanel]');
    if(panel){const tabs=panel.closest('studio-product-tabs');$$('[role=tab]',tabs||document).find(tab=>tab.getAttribute('aria-controls')===panel.id)?.click();}
    const slide=event.target.closest('.st-favorite');
    if(slide)slide.scrollIntoView({behavior:'auto',block:'nearest',inline:'nearest'});
  });
  document.addEventListener('shopify:section:unload',event=>{
    matching('[data-st-catalog-section]',event.target).forEach(section=>{const state=paginationState.get(section);state?.observer?.disconnect();state?.request?.abort();paginationState.delete(section);});
    matching('[data-st-facets]',event.target).forEach(details=>{facetState.get(details)?.abort();facetState.delete(details);});
  });
  window.addEventListener('storage',event=>{if(event.key==='studio.compare'){syncCompareButtons();$$('studio-catalog-compare:not([data-recommendations])').forEach(node=>node.load());}});
  Object.entries({'studio-catalog-rail':CatalogRail,'studio-catalog-recent':CatalogRecent,'studio-catalog-compare':CatalogComparison,'studio-catalog-expand':CatalogExpand}).forEach(([name,component])=>{if(!customElements.get(name))customElements.define(name,component);});
  window.StudioCatalog={init,loadMore,addCompare,removeCompare};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();
